import React, { useEffect, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import CloseIcon from 'web/assets/images/CloseIcon.png';
import { getGenToken } from 'redux/actions/profile'
import { certificateListPTMS  } from "redux/actions/adminPtPlus";
import { Modal,ModalBody, ModalFooter } from 'reactstrap';
import './yesNoModal.scss';

export default ({ isOpen, toggle, title, selectedState, content, link,id, onClickHander, getCetType, callBack }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  // const myContainer = useRef(null);
  const token = localStorage.getItem('token');
  const authId = localStorage.getItem('authId')
  const redirectLink = (link) => {
    if (link !== '/') {
      history.push(link);
    }
    toggle(!isOpen)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchMyAPI()
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const fetchMyAPI = useCallback(async () => {
    if (token === null) {
    } else {
      let response
      if(getCetType === "PTMS"){
        const authId = localStorage.getItem('adminAuthId')
        response = await dispatch(certificateListPTMS(token, id));
      }else{
        response = await dispatch(getGenToken(token, authId));
      }
      
      genCetFun(response.response.token)
      if (response.status === 'SUCCESS') {
      } else {
        if (response.message === "Unauthorized (Invalid token)") {
          history.push('/sign-in')
          window.location.reload(false);
        } else {

        }
      }
    }
  }, []);
  const genCetFun = (token) => {
    window.GenCert.init(document.getElementById("form_container"), {
      ship_zone: selectedState,
      token: token,
      edit_purchaser: true,
      onCertSuccess: function (e) {
        callBack()
      },
      onCancel: function (e) {
        callBack()
      },
      onManualSubmit: function (e) {
      },
      afterShow: function (e) {
      },
      onCertFailure: function (e) {
      },
      onNotNeeded: function (e) {
      },
      onSaveCustomer: function (e) {
      },
    });
    window.GenCert.show();
  }
  return (
    <div className='alert-modal'>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        className='genCert-modal'>
        <div className='modal-content'>
          <div className='header'>
            <Button handleClick={() => {
              toggle(!isOpen)
              onClickHander()
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <ModalBody>
            <div>
              <h3 className='modal-title'>{title}</h3>
            </div>
            <div>
              <div id="form_container"></div>
            </div>
          </ModalBody>
          <ModalFooter className='modal-footer'>
          </ModalFooter>
        </div>
      </Modal>
    </div>
  );
};
